import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

/**
 * Service for detecting the current platform.
 * Wraps Capacitor's platform detection for testability.
 */
@Injectable({
    providedIn: 'root'
})
export class PlatformDetectorService {
    /**
     * Check if the app is running on a native platform (iOS/Android).
     */
    isNativePlatform(): boolean {
        return Capacitor.isNativePlatform();
    }

    /**
     * Check if the app is running on the web platform.
     */
    isWebPlatform(): boolean {
        return !this.isNativePlatform();
    }

    /**
     * Get the current platform name.
     */
    getPlatform(): string {
        return Capacitor.getPlatform();
    }
}
